import React from 'react'
import ReviewAudit from 'components/ReviewAudit'
export default function Reviews({ id, userRole, actorId, activeEvent }) {
  return <ReviewAudit eventId={id} actorId={actorId} eventCompetitions={activeEvent?.competitions} canView={userRole === 'superAdmin'} />
}
